import React from "react";

const DislikeFilledIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M13.006 12.825V4.35833C13.006 3.84167 12.7643 3.35833 12.356 3.04167L11.2893 2.21667C10.931 1.85833 10.1477 1.66667 9.58932 1.66667H6.33932C5.22265 1.66667 4.09765 2.50833 3.83932 3.54167L1.78932 9.78333C1.58099 10.375 1.63932 10.9583 1.95599 11.4083C2.28932 11.875 2.85599 12.1417 3.51432 12.1417H6.93932C7.16432 12.1417 7.37265 12.2417 7.51432 12.4C7.65599 12.575 7.72265 12.8 7.68932 13.05L7.25599 15.775C7.08099 16.5917 7.62265 17.5083 8.43932 17.7833C9.19765 18.0667 10.0893 17.6833 10.4477 17.1417L12.7227 13.7583C12.906 13.4833 13.006 13.1583 13.006 12.825Z"
        fill="#070B12"
      />
      <path
        d="M16.5142 14.45H15.6559C14.3642 14.45 13.8392 13.95 13.8392 12.725V4.34167C13.8392 3.10834 14.3642 2.60834 15.6559 2.60834H16.5142C17.8059 2.60834 18.3309 3.10834 18.3309 4.34167V12.7167C18.3309 13.95 17.8059 14.45 16.5142 14.45Z"
        fill="#070B12"
      />
    </svg>
  );
};

export default DislikeFilledIcon;
